import * as amplitude from '@amplitude/analytics-browser';
import * as sessionReplay from '@amplitude/session-replay-browser';

const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || '';

let initialized = false;

/**
 * Initialize Amplitude analytics + session replay.
 * Call once at app startup (before any tracking).
 */
export function initAnalytics() {
  if (initialized || !AMPLITUDE_API_KEY) {
    if (!AMPLITUDE_API_KEY) {
      console.warn('[Analytics] Missing REACT_APP_AMPLITUDE_API_KEY — skipping init');
    }
    return;
  }

  amplitude.init(AMPLITUDE_API_KEY, {
    autocapture: {
      elementInteractions: true,
      pageViews: true,
      sessions: true,
    },
  });

  // Tag all events from this app as Flashtools
  const globalIdentify = new amplitude.Identify();
  globalIdentify.set('app_source', 'flashtools');
  amplitude.identify(globalIdentify);

  try {
    sessionReplay.init(AMPLITUDE_API_KEY, {
      sampleRate: 1,
    });
  } catch (err) {
    console.warn('[Analytics] Session replay init failed:', err);
  }

  initialized = true;
}

/**
 * Identify the current user. Call on login / auth state change.
 */
export function identifyUser(
  userId: string,
  properties?: Record<string, string | number | boolean>,
) {
  if (!initialized) return;

  amplitude.setUserId(userId);

  if (properties) {
    const identify = new amplitude.Identify();
    for (const [key, value] of Object.entries(properties)) {
      identify.set(key, value);
    }
    amplitude.identify(identify);
  }
}

/**
 * Clear user identity on logout.
 */
export function resetUser() {
  if (!initialized) return;
  amplitude.reset();
}

/**
 * Fire a custom event.
 *
 * Usage:
 *   trackEvent('ticket_transferred', { platform: 'dice', ticketCount: 3 });
 */
export function trackEvent(
  name: string,
  properties?: Record<string, string | number | boolean>,
) {
  if (!initialized) return;
  amplitude.track(name, { ...properties, app_source: 'flashtools' });
}
